import { CreateWorkerFromSelf } from "@pdfking/compatibility"

import { RequestHandler } from "../recipies/RequestHandler"
import { WorkerForward } from "../recipies/WorkerForward"
import type { Implementation } from "../types/Implementation"
import type { MessageRouter } from "../types/MessageRouter"
import type { WorkerReceiverAPI } from "../types/WorkerReceiver"

export const WorkerReceiver = <T, R>(
  func: Implementation<T, R>,
  worker?: WorkerReceiverAPI<T, R>
): MessageRouter<T, R> => {
  const forward: MessageRouter<T, R> = WorkerForward(
    worker ?? CreateWorkerFromSelf(),
    (...args) => runner(...args)
  )
  const runner: MessageRouter<T, R> = RequestHandler(func, forward)
  return forward
}
